import React from 'react';

import Lozenge from '@atlaskit/lozenge/lozenge';

export default (): React.JSX.Element => <Lozenge>Subtle default lozenge</Lozenge>;
